import React from 'react';
import {DevicePlatforms} from "../../common/Constants";
import AppGlobals from "../../common/AppGlobals";
import PropTypes from 'prop-types';

class PlatformRender extends React.Component {

    constructor(props){
        super(props);

        this.state= {
            platform: props.platform
        };

    }

    componentWillUnmount(){

        if(this.canRender()){

            if(this.props.onDeactivate)
                this.props.onDeactivate();

        }

    }

    componentDidMount() {

        if(this.canRender()){
            if(this.props.onActivate){
                this.props.onActivate();
            }
        }

    }

    canRender(){

        const isMobile = AppGlobals.get('isMobile');

        switch (this.state.platform){
            case DevicePlatforms.Desktop:
                return !isMobile;
            case DevicePlatforms.Mobile:
                return isMobile;
            default:
                return false;
        }

    }

    render(){

        if(this.canRender()){
            return this.props.children;
        }

        return null;
    }

}

PlatformRender.propTypes = {
    platform: PropTypes.string,
    onActivate: PropTypes.func,
    onDeactivate: PropTypes.func
};

PlatformRender.defaultProps = {
    platform: 'desktop'
};


export default PlatformRender;


// WEBPACK FOOTER //
// ./src/components/PlatformRender/PlatformRender.js